import { render, staticRenderFns } from "./passRecords.vue?vue&type=template&id=39077828"
import script from "./passRecords.vue?vue&type=script&lang=js"
export * from "./passRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports